import { Status } from '@brighterly/lib-core-types/booking/enums'

export const listDemoNoShowStatuses = [
  Status.NoShow,
  Status.Canceled,
  Status.CanceledBad,
]

export const listDemoBookingRequestStatuses = [
  Status.Planned,
  Status.Confirmed,
  Status.InProgress,
  Status.Completed,
  ...listDemoNoShowStatuses,
]

export const listBookingRequestStatuses = [
  Status.Planned,
  Status.InProgress,
  Status.Confirmed,
  Status.ReservedConfirmed,
  Status.ReservedPlanned,
]

export const listFallbackBookingRequestStatuses = [
  Status.Completed,
  Status.NoShow,
  Status.Canceled,
  Status.CanceledBad,
]

export const listPaidBookingRequestStatuses = [
  Status.Planned,
  Status.Confirmed,
  Status.InProgress,
  Status.ReservedConfirmed,
  Status.ReservedPlanned,
]

export const listFinishedBookingRequestStatuses = [
  Status.Completed,
  Status.Rescheduled,
  Status.RescheduledBad,
  ...listDemoNoShowStatuses,
]
